<span
  [matTooltip]="dateTooltip" 
  [ixTest]="[title, rowTestId(row), 'row-relative-date']"
>{{ date }}</span>
